<template>
  <div>
    <div>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <div v-if="hasPermissionToRead">

            <!-- Table Container Card -->
            <b-card
              no-body
              class="mb-0"
            >

              <div class="mr-2 ml-2 mt-1 mb-1">
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <div>
                      <b-form-group
                        label="Exibir"
                        label-for="idSearchBox"
                        class="mb-0"
                      >
                        <v-select
                          id="idSearchBox"
                          v-model="perPage"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="perPageOptions"
                          :clearable="false"
                          class="per-page-selector d-inline-block"
                        >
                          <span slot="no-options">Não há opções para essa quantidade.</span>
                        </v-select>
                      </b-form-group>
                    </div>
                    <b-form-input
                      v-model.lazy="searchQuery"
                      placeholder="Buscar"
                      type="text"
                      class="d-inline-block mt-2 ml-1"
                    />
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <div>
                        <b-dropdown
                          v-b-tooltip.hover
                          title="Exibir colunas"
                          class="dropBtnTableToolbar mt-2 ml-2"
                          toggle-class="rounded-circle customDropdown"
                          variant="none"
                          size="md"
                          no-caret
                          offset="-120"
                          :dropup="true"
                          :boundary="'scrollParent'"
                        >

                          <template #button-content>
                            <svg-icon
                              type="mdi"
                              size="24"
                              :path="mdiTableEdit"
                            />
                          </template>
                          <b-dropdown-text
                            class="showColumnsDropdown"
                          >
                            Exibir Colunas
                          </b-dropdown-text>

                          <b-dropdown-divider />
                          <b-dropdown-form>
                            <b-form-checkbox
                              v-for="(column, index) in tableColumns"
                              :key="index"
                              v-model="tableColumns[index].visible"
                              :value="true"
                              :unchecked-value="false"
                              :class="{ 'd-none': tableColumns[index].fixedColumn }"
                              class="mb-1"
                            >
                              {{ column.label }}
                            </b-form-checkbox>
                          </b-dropdown-form>

                        </b-dropdown>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-table
                class="position-relative"
                primary-key="id"
                responsive
                show-empty
                striped
                hover
                empty-text="Não há fornecedors cadastrados."
                :items="suppliers"
                :fields="visibleFields"
                :busy="isLoading"
                :sort-by.sync="sortOptions.sortBy"
                :sort-desc.sync="sortOptions.isSortDirDesc"
                @row-clicked="onRowSelected"
              >
                <template #table-busy>
                  <div class="text-center my-3">
                    <b-spinner
                      variant="info"
                      class="align-middle mb-1"
                    />
                    <br>
                    <strong class="pt-2">Carregando ...</strong>
                  </div>
                </template>

                <template #cell(id)="data">
                  <b-media vertical-align="center">
                    <b-link
                      class="font-weight-bold d-block text-nowrap"
                      @click="onRowSelected(data.item)"
                    >
                      #{{ data.item.id }}
                    </b-link>
                  </b-media>
                </template>

                <template #cell(name)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold text-nowrap">
                      {{ data.item.name | truncate(40, '...') }}
                    </span>
                  </b-media>
                </template>

                <template #cell(cnpj)="data">
                  <div
                    v-if="data.item.cnpj"
                  >
                    {{ data.item.cnpj | VMask('##.###.###/####-##') }}
                  </div>
                  <div v-else>
                    <span class="font-weight-bold">-</span>
                  </div>
                </template>

                <template #cell(category__name)="data">
                  <div
                    v-if="data.item.category_set.length > 0"
                  >
                    <div
                      v-for="(element, index) in data.item.category_set"
                      :key="index"
                    >
                      <b-badge
                        class="text-capitalize categoryBagde"
                        variant="info"
                      >
                        {{ element.name | truncate(18, '...') }}
                      </b-badge>
                    </div>
                  </div>
                  <div v-else>
                    <span class="font-weight-bold">-</span>
                  </div>
                </template>

                <template #cell(phone_number)="data">
                  <div
                    v-if="data.item.phone_number"
                  >
                    {{ data.item.phone_number }}
                  </div>
                  <div v-else>
                    <span class="font-weight-bold">-</span>
                  </div>
                </template>

                <template #cell(city__name)="data">
                  <div
                    v-if="data.item.city_set"
                    class="text-nowrap"
                  >
                    <span class="align-text-top text-capitalize">{{ data.item.city_set.name }}</span>
                  </div>
                  <div
                    v-else
                    class="text-nowrap"
                  >
                    <span class="font-weight">-</span>
                  </div>
                </template>
                <template #cell(state__name)="data">
                  <div
                    v-if="data.item.state_set"
                    class="text-nowrap"
                  >
                    <span class="align-text-top text-capitalize">{{ data.item.state_set.code }}</span>
                  </div>
                  <div
                    v-else
                    class="text-nowrap"
                  >
                    <span class="align-text-top text-capitalize">-</span>
                  </div>
                </template>

                <template #cell(field_actions)="data">
                  <div
                    :class="totalItems > 1 ? '' : 'dropdownfix'"
                  >
                    <b-dropdown
                      id="actions"
                      variant="link"
                      no-caret
                      :dropup="true"
                      :boundary="'scrollParent'"
                      :right="$store.state.appConfig.isRTL"
                    >

                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </template>

                      <b-dropdown-item
                        :to="{ name: 'supplier-detail', params: { id: data.item.id }}"
                      >
                        <feather-icon icon="FileTextIcon" />
                        <span class="align-middle ml-50">Detalhes</span>
                      </b-dropdown-item>

                      <b-dropdown-item
                        :disabled="!hasPermissionToUpdate"
                        :to="{ name: 'supplier-edit', params: { id: data.item.id } }"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">Editar</span>
                      </b-dropdown-item>

                      <b-dropdown-item
                        :disabled="!hasPermissionToDelete"
                        @click="showConfirmOrCancelDelete(data.item)"
                      >
                        <svg-icon
                          type="mdi"
                          size="16"
                          :path="mdiTrashCanOutline"
                        />
                        <span class="align-middle ml-50">Remover</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>
              </b-table>
              <div class="mx-2 mb-2">
                <b-row>
                  <b-col
                    cols="12"
                    class="d-flex align-items-center justify-content-center"
                  >

                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalItems"
                      :per-page="perPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>

                  </b-col>
                </b-row>
              </div>
            </b-card>
          </div>
        </b-col>
      </b-row>
      <div>
        <b-button
          id="addSupplierBtn"
          v-b-tooltip.hover
          class="btn-icon rounded-circle m-3"
          variant="primary"
          size="md"
          :to="{ name: 'supplier-create'}"
          :disabled="!hasPermissionToWrite"
          title="Adicionar fornecedor"
        >
          <svg-icon
            type="mdi"
            :path="mdiPlus"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
  BRow,
  BCol,
  BButton,
  BTable,
  BMedia,
  BLink,
  BDropdown,
  BDropdownItem,
  BDropdownText,
  BDropdownForm,
  BDropdownDivider,
  BPagination,
  BSpinner,
  BBadge,
  VBTooltip,
} from 'bootstrap-vue'

import {
  mdiTableEdit,
  mdiTableColumn,
  mdiPlus,
  mdiTrashCanOutline,
} from '@mdi/js'

import {
  useToast,
} from 'vue-toastification/composition'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SvgIcon from '@jamescoyle/vue-icon'
import router from '@/router'
import syslic from '@/syslic'
import truncate from '@/components/utils/filters/truncate'
import MetaData from '@/components/utils/metaData'
import debounce from '@/components/utils/debounce'

export default {
  components: {
    BCard,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BRow,
    BCol,
    BButton,
    BTable,
    BMedia,
    BLink,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BDropdownForm,
    BDropdownDivider,
    BPagination,
    BSpinner,
    BBadge,
    vSelect,
    SvgIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  filters: {
    truncate,
  },
  data() {
    const perPage = 10
    const totalItems = 0
    const currentPage = 1
    const searchQuery = ''

    const sortOptions = {
      sortBy: 'name',
      isSortDirDesc: false,
    }

    const perPageOptions = [10, 25, 50, 100]

    const tableColumns = [
      {
        key: 'id',
        label: 'Id',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'name',
        label: 'Razão Social',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'cnpj',
        label: 'CNPJ',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'category__name',
        label: 'Categoria',
        sortable: false,
        visible: false,
        fixedColumn: false,
      },
      {
        key: 'phone_number',
        label: 'Telefone',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'city__name',
        label: 'Cidade',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'state__name',
        label: 'Estado',
        sortable: true,
        visible: true,
        fixedColumn: false,
      },
      {
        key: 'field_actions',
        label: '',
        thClass: 'text-nowrap supplierTableAction',
        tdClass: 'supplierTableAction',
        visible: true,
        fixedColumn: true,
      },
    ]
    const suppliers = []

    const isLoading = true

    const fetchId = ''

    const meta = new MetaData('ProductTable')

    return {
      perPage,
      totalItems,
      currentPage,
      searchQuery,
      perPageOptions,
      tableColumns,
      suppliers,
      isLoading,
      sortOptions,
      fetchId,
      meta,
    }
  },
  computed: {
    hasPermissionToRead() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.supplier.can_read
    },
    hasPermissionToWrite() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.supplier.can_write
    },
    hasPermissionToUpdate() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.supplier.can_edit
    },
    hasPermissionToDelete() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.supplier.can_delete
    },
    visibleFields() {
      return this.tableColumns.filter(field => field.visible)
    },
  },
  watch: {
    perPage: 'fetchData',
    currentPage: 'fetchData',
    searchQuery: function updateSearchQuery(value) {
      this.currentPage = 1
      this.searchQuery = value
      this.fetchData()
    },
    'sortOptions.sortBy': 'fetchData',
    'sortOptions.isSortDirDesc': 'fetchData',
  },
  created() {
    this.tableColumns = this.meta.bind(this.tableColumns, 'tableColumns')
    this.sortOptions = this.meta.bind(this.sortOptions, 'sortOptions')
    this.fetchData()
  },
  methods: {
    refreshColumns(columns) {
      columns.forEach(element => {
        this.tableColumns.forEach((obj, i) => {
          if (obj.key === element.key) {
            this.tableColumns[i].visible = element.visible
          }
        })
      })
    },
    fetchData() {
      this.isLoading = true
      debounce.call(this.fetch)
    },
    fetch() {
      const fetchPending = Math.random()
      this.fetchId = fetchPending

      const params = {
        p: this.currentPage,
        page_size: this.perPage,
        search: this.searchQuery,
      }

      if (this.sortOptions.isSortDirDesc) {
        params.ordering = `-${this.sortOptions.sortBy}`
      } else {
        params.ordering = this.sortOptions.sortBy
      }

      syslic
        .supplier
        .fetchSupplierList(params)
        .then(response => {
          if (fetchPending === this.fetchId) {
            this.totalItems = response.data.count
            this.suppliers = response.data.results
            this.isLoading = false
          }
        })
        .catch(() => {
          if (fetchPending === this.fetchId) {
            this.toast({
              component: ToastificationContent,
              props: {
                title: 'Falha ao ler os dados dos fornecedores.',
                text: 'Não foi possível ler os dados dos fornecedores no servidor, por favor entre em contato com o administrador do sistema.',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                timeout: false,
              },
            })
            this.isLoading = false
          }
        })
    },
    deleteSupplier(item) {
      syslic
        .supplier
        .deleteSupplier(item.id)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Fornecedor removido com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.suppliers.splice(this.suppliers.indexOf(item), 1)
        })
        .catch(error => {
          let textError = 'Não foi possível remover o fornecedor do servidor, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.includes('they are referenced through protected foreign keys')) {
              textError = 'Este fornecedor é referenciado em algum produto, por este motivo não será possível exclui-lo.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao remover fornecedor.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    showConfirmOrCancelDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Por favor, confirme que você deseja remover este fornecedor.', {
          id: 'confirmation_box',
          title: 'Confirmar?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-primary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteSupplier(item)
          }
        })
    },
    onRowSelected(item) {
      router.push({ name: 'supplier-detail', params: { id: item.id } }).catch(() => {})
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
      mdiTableEdit,
      mdiTableColumn,
      mdiPlus,
      mdiTrashCanOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.dropdownfix .dropdown.show{
  position: fixed;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#addSupplierBtn {
  position: fixed;
  right: 0;
  bottom: 0;
}

.categoryBagde {
  fill: #ffffff;
}

.customDropdown {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 !important;

  height: 3rem !important;
  width: 3rem !important;

  &:hover {
    background-color: rgba(226, 235, 248, 0.882) !important;
  }

  > svg {
    color: $primary;
  }
}

</style>
